import { ShareRequestDto, AccessPermissionsDto, UserAccessRequestDto, RoleAccessRequestDto } from "../types/ShareResource";
import { UserDto } from "../types/User";
import apiClient from "../utils/apiClient";

export const getActiveUsers = async (userName?: string): Promise<UserDto[]> => {
  const response = await apiClient.get<UserDto[]>(`/portal/ShareResource/active-users/${userName}`);
  return response.data;
};


export const getRecursiveParentFolderIds = async (folderId?: number): Promise<(number | null)[]> => {
  const response = await apiClient.get<(number | null)[]>(`/portal/ShareResource/recursive-parentFolderIds/${folderId}`);
  return response.data;
};

export const getUserAccessPermissions = async (userAccessRequestDto: UserAccessRequestDto): Promise<AccessPermissionsDto[]> => {
  const response = await apiClient.post<AccessPermissionsDto[]>(`/portal/ShareResource/user-permissions`, userAccessRequestDto);
  return response.data;
};

export const getRoleAccessPermissions = async (roleAccessRequestDto: RoleAccessRequestDto): Promise<AccessPermissionsDto[]> => {
  const response = await apiClient.post<AccessPermissionsDto[]>(`/portal/ShareResource/role-permissions`, roleAccessRequestDto);
  return response.data;
};

export const share = async (shareRequestDto: ShareRequestDto): Promise<boolean> => {
  const response = await apiClient.post<boolean>(`/portal/ShareResource/share`, shareRequestDto);
  return response.data;
}; 